/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AccreditationEstablishmentAliases {
  CHECKBOX_SUS = 'checkbox-sus',
  FETCH_CITY = 'fetch-city',
  FETCH_COUNTRY = 'fetch-country',
  FETCH_ESTABLISHMENT_TYPE = 'fetch-establishment-type',
  FETCH_PENDENCIES = 'fetch-pendencies',
  FETCH_STATE = 'fetch-state',
  FETCH_STREET_TYPE = 'fetch-Street-type',
  FIELD_0 = 'field-0',
  FIELD_10 = 'field-10',
  FIELD_ADDRESS = 'field-address',
  FIELD_CD_CNES = 'field-cdCnes',
  FIELD_CITY = 'field-city',
  FIELD_CITY_REGISTRATION = 'field-cityRegistration',
  FIELD_CNPJ_MATRIZ = 'field-cnpj-matriz',
  FIELD_COMPLEMENT = 'field-complement',
  FIELD_CORPORATE_NAME = 'field-corporateName',
  FIELD_COUNTRY = 'field-country',
  FIELD_EMAIL = 'field-email',
  FIELD_ESTABLISHMENT_TYPE = 'field-establishment-type',
  FIELD_FANTASY_NAME = 'field-fantasyName',
  FIELD_IE_TYPE_SECRETARY = 'field-ieTypeSecretary',
  FIELD_LATITUDE = 'field-latitude',
  FIELD_LONGITUDE = 'field-longitude',
  FIELD_NEIGHBORHOOD = 'field-neighborhood',
  FIELD_NR_ADDRESS = 'field-nrAddress',
  FIELD_NR_CNPJ = 'field-nrCnpj',
  FIELD_PHONE = 'field-phone',
  FIELD_POSTAL_CODE = 'field-postalCode',
  FIELD_SITE = 'field-site',
  FIELD_STATE = 'field-state',
  FIELD_STATE_REGISTRATION = 'field-stateRegistration',
  FIELD_STREET_TYPE = 'field-street-type',
  FIELD_SUS = 'field-sus',
  FIELD_WORKING_HOURS = 'field-working-hours',
  FORM_0 = 'form-0',
  FORM_ESTABLISHMENT = 'form-establishment',
  INPUT_0 = 'input-0',
  INPUT_1 = 'input-1',
  INPUT_ADDRESS = 'input-address',
  INPUT_CD_CNES = 'input-cdCnes',
  INPUT_CITY_REGISTRATION = 'input-cityRegistration',
  INPUT_COMPLEMENT = 'input-complement',
  INPUT_CORPORATE_NAME = 'input-corporateName',
  INPUT_CPNPJ_MATRIZ = 'input-cpnpj-matriz',
  INPUT_EMAIL = 'input-email',
  INPUT_FANTASY_NAME = 'input-fantasyName',
  INPUT_NEIGHBORHOOD = 'input-neighborhood',
  INPUT_NR_ADDRESS = 'input-nrAddress',
  INPUT_POSTAL_CODE = 'input-postalCode',
  INPUT_SITE = 'input-site',
  INPUT_STATE_REGISTRATION = 'input-stateRegistration',
  INPUT_WORKING_HOURS = 'input-working-hours',
  LAYOUT_0 = 'layout-0',
  MAPPER_0 = 'mapper-0',
  MAPPER_10 = 'mapper-10',
  MAPPER_CITY = 'mapper-city',
  MAPPER_COUNTRY = 'mapper-country',
  MAPPER_STATE = 'mapper-state',
  MAPPER_STREET_TYPE = 'mapper-Street-type',
  PANEL_CNES = 'panel-cnes',
  PANEL_ESTABLISHMENT = 'panel-establishment',
  PANEL_PENDENCIES = 'panel-pendencies',
  PANEL_TITLE = 'panel-title',
  PHONE_NUMBER_0 = 'phone-number-0',
  RADIO_GROUP_ESTABLISHMENT_TYPE = 'radio-group-establishment-type',
  RADIO_GROUP_IE_TYPE_SECRETARY = 'radio-group-ieTypeSecretary',
  TEXT_0 = 'text-0',
  TEXT_3 = 'text-3',
  TEXT_10 = 'text-10',
  TEXT_CITY = 'text-city',
  TEXT_COUNTRY = 'text-country',
  TEXT_STATE = 'text-state',
  TEXT_STREET_TYPE = 'text-street-type',
  TOAST_NOTIFICATION = 'toast-notification',
  TOAST_NOTIFICATION_CNES = 'toast-notification-cnes',
  UNBOXED_AUTOCOMPLETE_0 = 'unboxed-autocomplete-0',
  UNBOXED_AUTOCOMPLETE_CITY = 'unboxed-autocomplete-city',
  UNBOXED_AUTOCOMPLETE_COUNTRY = 'unboxed-autocomplete-country',
  UNBOXED_AUTOCOMPLETE_STATE = 'unboxed-autocomplete-state',
  UNBOXED_AUTOCOMPLETE_STREET_TYPE = 'unboxed-autocomplete-Street-type',
}
export { AccreditationEstablishmentAliases };
